import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { Console } from 'console';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { RefreshComponent } from 'src/app/core/grid-renderer/refresh/refresh.component';
import { AddresolutionordersService } from 'src/app/services/addresolutionorders.service';

@Component({
  selector: 'app-add-resolution-orders',
  templateUrl: './add-resolution-orders.component.html',
  styleUrls: ['./add-resolution-orders.component.scss'],
  standalone: false // NOSONAR
})
export class AddResolutionOrdersComponent implements OnInit {
  gridApi: any;
  highlightUnVerified: any = false;
  highlightVerified: any = false;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  selectedPlant: any = '-1';
  selectedTab: any;
  successMessage: any;
  errorMessage: any;
  removeData: any[] = [];
  addData: any[] = [];
  selectedRemove: any[];
  selectedAdd: any[];
  list: any;
  dropdownOptionPlant: any[] = [];
  findRouteData: any[] = [];
  allResolutionOrders: any[] = [];
  owkResponse: any[] = [];
  resolutionId: any;
  loadNumber: any;
  eta: any;
  unloadDate: any;
  route: any;
  setResolutionType: any;
  destination: any;
  supplier: any = null;
  dock: string;
  unload: any;
  errorMessageRemove: any;
  errorMessageAdd: any;

  constructor(
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly addResolutionOrdersService: AddresolutionordersService,
    public constants: Constants,
    private readonly DatePipe: DatePipe,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.selectedTab = 'remove';
    this.highlightUnVerified = true;
    this.resolutionId = localStorage.getItem('resolutionId');
    this.removeExistingGrid();
    this.setupResolutionWizardAPI();
  }
  //Integrated Method
  setupResolutionWizardAPI() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.addResolutionOrdersService.setupResolutionWizard(parseInt(this.resolutionId)).subscribe({
      next: (response) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.list = response;
        this.loadNumber = this.list.editResolution.load_number;
        this.eta = this.dateFormatter(this.list.editResolution.eta);
        this.unload = this.list.editEvent.arrival;
        this.unloadDate = this.DatePipe.transform(this.unload, 'yyyy-MM-dd');
        this.route = this.list.editEvent.puroute;
        if (this.list.editResolution.logistics_point == '-1' || this.list.editResolution.logistics_point == null) { // NOSONAR
          this.destination = null;
        }
        else {
          this.destination = this.list.editResolution.logistics_point;
        }
        this.list.resolutionTypes.forEach(element5 => {
          if (element5.resolutionId == this.list.editResolution.resolution_type_id) { // NOSONAR
            this.setResolutionType = element5.description;
          }
        });
        if (this.list.domicileList && this.list.domicileList.length > 0) {
          this.list.domicileList.sort((a, b) => {
            const descA = a.itemDesc?.toLowerCase() ?? '';
            const descB = b.itemDesc?.toLowerCase() ?? '';

            if (descA < descB) {return -1;}
            if (descA > descB) {return 1;}
            return 0;
          });

          this.dropdownOptionPlant = [];
          this.dropdownOptionPlant.push({
            label: '-1',
            value: 'ALL',
          });
          this.list.domicileList.forEach((obj, _index) => {
            this.dropdownOptionPlant.push({
              label: obj.itemCode,
              value: obj.itemCode,
            });
          });
        }
      },
      error: () => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      },
    });
  }
  removeExisting() {
    this.highlightUnVerified = true;
    this.highlightVerified = false;
    this.selectedTab = 'remove';
  }

  addOrders() {
    this.highlightUnVerified = false;
    this.highlightVerified = true;
    this.selectedTab = 'add';
    this.addData = [];
  }

  removeExistingGrid() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.successMessage = null;
    this.errorMessage = null;
    this.addResolutionOrdersService.getResolutionOrders(parseInt(this.resolutionId)).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.removeData = response;

      },
      error: () => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      },
    });
  }

  addOrdersGrid() {


    const responseBody = {
      unloadDate: this.unload,
      puroute: this.route,
    };
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.addResolutionOrdersService.findRouteDetails(responseBody).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.findRouteData = response;
        if (this.findRouteData.length == 0 || this.findRouteData == null) { // NOSONAR
          this.errorMessage = null;
          this.errorMessage = 'System cannot find routes for the data provided';
        } else if (this.findRouteData.length == 1) { // NOSONAR
          console.info('Inside If');
          this.searchForOrders(); //API CALL FOR GRID IN ADD TAB IN THIS METHOD
        } else {
          console.info('Hello Check');
        }
      },
      error: () => {
        this.errorMessage = null;
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      },
    });
  }
  searchForOrders() {
    //API CALL FOR GRID IN ADD TAB IN THIS METHOD
    const gridResponseBody = {
      owk_arrival: this.unload,
      owk_puroute: this.route,
      owk_supplierid: this.supplier,
      owk_plantid: this.selectedPlant,
      owk_dockid: this.dock ? this.dock.toUpperCase() : null,
    };
    console.info('Inside Search for Orders');
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.successMessage = null;
    this.errorMessage = null;
    this.addResolutionOrdersService.getOwkOrders(gridResponseBody).subscribe({
      next: (response: any) => {

        this.owkResponse = response;

        this.addResolutionOrdersService.getAllResolutionOrders().subscribe({
          next: (response: any) => {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.allResolutionOrders = response;
            this.addData = [];
            this.owkResponse.forEach((element) => {
              let flag = true;
              const workList = this.allResolutionOrders.filter((value) => {
                if ( element.puRoute == value.puRoute && element.region == value.region && element.supplierId == value.supplierId && element.plantId == value.plantId && element.logicalDockId == value.logicalDockId && element.orderNumber == value.orderNumber ) { // NOSONAR
                  return true;
                }
                return false;
              });
              workList.forEach((element2) => {
                if (
                  this.dayFormatterNotUTC(element.arrival) ===
                  this.dayFormatterNotUTC(element2.arrival)
                ) {
                  flag = false;
                }
              });

              const insertedList = this.allResolutionOrders.filter((value2) => {
                if ( element.orderNumber == value2.orderNumber && element.logicalDockId == value2.logicalDockId && element.puRoute == value2.puRoute && element.plantId == value2.plantId ) { // NOSONAR
                  return true;
                }
                return false;
              });

              insertedList.forEach((element3) => {
                if (
                  this.dayFormatterNotUTC(element.arrival) ===
                  this.dayFormatterNotUTC(element3.arrival)
                ) {
                  flag = false;
                }
              });
              if (flag) {
                this.addData.push(element);

              }
            });
          },
          error: () => {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.errorMessage = this.constants.APIErrorMessage;
          },
        });
      },
      error: () => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      },
    });
  }
  onRemoveOrders(event) {

    this.selectedRemove = event;
  }
  onAddOrders(event) {

    this.selectedAdd = event;
  }

  removeBtn() {
    this.successMessage = null;
    this.errorMessage = null;
    if (this.selectedRemove == null || this.selectedRemove == undefined || this.selectedRemove.length == 0 || this.removeData.length == 0) { // NOSONAR
      this.errorMessageRemove = null;
      this.errorMessageRemove = 'Please select at least one item from the grid';
    }
    else {
      const eventId = localStorage.getItem('eventId');
      this.ngxUiLoaderService.start(CommonConstant.loader);
      this.addResolutionOrdersService
        .deleteResolutionOrders(this.selectedRemove, eventId)
        .subscribe({
          next: (response: any) => {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.removeExistingGrid();
            this.successMessage = response;
            setTimeout(() => {
              this.errorMessage = null;
              this.successMessage = null;
            }, 5000);
          },
          error: () => {
            this.errorMessage = null;
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.errorMessage = 'Error in Removing the Order(s)';
          },
        });
    }
  }
  year_frmt = 'MM-dd-yyyy'
  addBtn() {
    this.successMessage = null;
    this.errorMessage = null;
    if (this.selectedAdd == null || this.selectedAdd == undefined || this.selectedAdd.length == 0 || this.addData.length == 0) { // NOSONAR
      this.errorMessageAdd = null;
      this.errorMessageAdd = 'Please select at least one item from the grid';
    }
    else {
      this.selectedAdd = this.selectedAdd?.map((element: any) => {
        return {
          ...element,
          arrival: this.dateConverter(element.arrival),
          reloadStart: this.dateConverter(element.reloadStart),
          route1Unload: this.dateConverter(element.route1Unload),
          route1Reload: this.dateConverter(element.route1Reload),
          route2Unload: this.dateConverter(element.route2Unload),
          route2Reload: this.dateConverter(element.route2Reload),
          route3Unload: this.dateConverter(element.route3Unload),
          route3Reload: this.dateConverter(element.route3Reload),
          // route4Unload:this.dateConverter(element.route4Unload),
          // plantUnload:this.dateConverter(element.plantUnload),
        };
      });
      this.selectedAdd = this.selectedAdd?.map((element: any) => { // NOSONAR
        return {
          arrival: element.arrival
            ? this.DatePipe.transform(
              element.arrival?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.arrival?.substring(11, 19)
            : null,
          assignedLp: element.assignedLp ? element.assignedLp : '',
          logicalDockId: element.logicalDockId ? element.logicalDockId : '',
          mtmCode: element.mtmCode ? element.mtmCode : '',
          nextRoute: element.nextRoute ? element.nextRoute : '',
          orderNumber: element.orderNumber ? element.orderNumber : '',
          plantId: element.plantId ? element.plantId : '',
          plantUnload: element.plantUnload
            ? this.DatePipe.transform(
              element.plantUnload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.plantUnload?.substring(11, 19)
            : null,
          puRoute: element.puRoute ? element.puRoute : '',
          region: element.region ? element.region : '',
          reloadStart: element.reloadStart
            ? this.DatePipe.transform(
              element.reloadStart?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.reloadStart?.substring(11, 19)
            : null,
          resolutionId: this.resolutionId,
          route: element.route ? element.route : '',
          route1: element.route1 ? element.route1 : '',
          route1Region: element.route1Region ? element.route1Region : '',
          route1Unload: element.route1Unload
            ? this.DatePipe.transform(
              element.route1Unload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route1Unload?.substring(11, 19)
            : null,
          route1Reload: element.route1Reload
            ? this.DatePipe.transform(
              element.route1Reload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route1Reload?.substring(11, 19)
            : null,
          route2: element.route2 ? element.route2 : '',
          route2Region: element.route2Region ? element.route2Region : '',
          route2Unload: element.route2Unload
            ? this.DatePipe.transform(
              element.route2Unload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route2Unload?.substring(11, 19)
            : null,
          route2Reload: element.route2Reload
            ? this.DatePipe.transform(
              element.route2Reload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route2Reload?.substring(11, 19)
            : null,
          route3: element.route3 ? element.route3 : '',
          route3Region: element.route3Region ? element.route3Region : '',
          route3Unload: element.route3Unload
            ? this.DatePipe.transform(
              element.route3Unload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route3Unload?.substring(11, 19)
            : null,
          route3Reload: element.route3Reload
            ? this.DatePipe.transform(
              element.route3Reload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route3Reload?.substring(11, 19)
            : null,
          route4: element.route4 ? element.route4 : '',
          route4Region: element.route4Region ? element.route4Region : '',
          route4Unload: element.route4Unload
            ? this.DatePipe.transform(
              element.route4Unload?.substring(0, 10),
              this.year_frmt
            ) +
            ' ' +
            element.route4Unload?.substring(11, 19)
            : null,
          run: element.run ? element.run : '',
          supplierId: element.supplierId ? element.supplierId : '',
          supplierId1: element.supplierId1 ? element.supplierId1 : '',
        };
      });
      const eventId = localStorage.getItem('eventId');
      this.ngxUiLoaderService.start(CommonConstant.loader);
      this.addResolutionOrdersService
        .addResolutionOrders(this.selectedAdd, eventId)
        .subscribe({
          next: (response: any) => {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.searchForOrders();
            this.removeExistingGrid();
            this.successMessage = response;
            setTimeout(() => {
              this.errorMessage = null;
              this.successMessage = null;
            }, 5000);
          },
          error: () => {
            this.errorMessage = null;
            this.errorMessage = 'Error in Adding the Order(s)';
            this.ngxUiLoaderService.stop(CommonConstant.loader);
          },
        });
    }
  }
  dateFormatter(res) {
    if (res == null) { return ''; } // NOSONAR
    else { return moment(res).format('MM/DD/YYYY HH:mm'); }
  }
  dayFormatterNotUTC(res) {
    if (res == null) { return ''; } // NOSONAR
    else { return moment(res).format('MM/DD/YYYY'); }
  }
  dateConverter(val) {
    if (val == null) { return ''; } // NOSONAR
    else { return moment(val).format('MM/DD/YYYY HH:mm:ss'); }
  }
  addResolutionBtn() {
    this.router.navigate(['/dashboard/resolutions/add-resolution']);
  }
  close() {
    this.errorMessageAdd = null;
    this.errorMessageRemove = null;
  }
}
